import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { hasWorkspaceCapability } from "@/lib/access";
import WorkspaceAccessDialog from "@/components/WorkspaceAccessDialog";

export default function WorkspaceRoute({ capability, children }) {
  const navigate = useNavigate();
  const { user, t } = useApp();
  const [open, setOpen] = useState(true);
  if (hasWorkspaceCapability(user, capability)) return children;

  return (
    <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-8 text-center">
      <LockKeyhole className="mx-auto h-8 w-8 text-[#0F4C5C]" />
      <h1 className="mt-3 font-head text-2xl font-semibold text-slate-900">{t("workspaceAccess.lockedPageTitle")}</h1>
      <p className="mt-2 text-sm text-slate-500">{t("workspaceAccess.lockedPageDescription")}</p>
      <div className="mt-5 flex justify-center gap-3">
        <Button variant="outline" onClick={() => navigate("/app")}>{t("workspaceAccess.backWorkspace")}</Button>
        <Button onClick={() => setOpen(true)} className="bg-[#0F4C5C] hover:bg-[#0c3f4c]">{t("workspaceAccess.seePlan")}</Button>
      </div>
      <WorkspaceAccessDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
